import { Image } from '@/api'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const imageUrl = (image: Image) =>
  process.env.NODE_ENV === 'production'
    ? image.imageUrl
    : `http://localhost:8080${image.imageUrl}`

export const calcListingPriceRange = (prices: number[]) => {
  const min = Math.min(...prices)
  const max = Math.max(...prices)
  return { min, max }
}

export const createListingPriceRangeText = (prices: number[]) => {
  if (prices.length === 0) return null
  const { min, max } = calcListingPriceRange(prices)
  return min === max
    ? `¥${min.toLocaleString()}`
    : `¥${min.toLocaleString()} - ¥${max.toLocaleString()}`
}

export const validPrice = (
  price: number | null | undefined
): price is number => {
  return price !== null && price !== undefined
}

export const formatMaskedCardNo = (maskedCardNo: string | null | undefined) => {
  if (!maskedCardNo) return ''
  return maskedCardNo.replace(/.*(\d{4})$/, '•••••••••••$1')
}
